(function (angular) {
    'use strict';

    angular.module('reports')

        .controller('LiveChatCtrl', ['$q', '$scope', '$stateParams', 'liveChatService', 'teamSettingsService', "jwtService", "usersService", "sharedChartService",
            function ($q, $scope, $stateParams, liveChatService, teamSettingsService, jwtService, usersService, sharedChartService) {

                $scope.onTeamChanged = function () {
                    liveChatService.setTeam($scope.currentTeamId);
                }

                function resolveOnNotFound(result) {
                    return result.then(function (r) {
                        return $q.resolve(r);
                    }).catch(function (e) {
                        if (e.status === 404) {
                            return $q.resolve({});
                        } else {
                            return $q.reject(e);
                        }
                    })
                }

                // get list of teams and agents
                function initialise() {

                    var _config;
                    var _users;

                    return usersService.getUsers(jwtService.payload.accountId)
                        .then(function (users) {
                            _users = users;
                            return resolveOnNotFound(teamSettingsService.getChatConfig($stateParams.pickedApiSpaceId));
                        })
                        .then(function (config) {
                            _config = config;
                            return teamSettingsService.getTeams($stateParams.pickedApiSpaceId)
                        })
                        .then(function (result) {

                            $scope.teams = result;

                            if ($scope.teams.length) {
                                var savedTeamId = sharedChartService.initialiseWatch($scope, "currentTeamId", $stateParams.pickedApiSpaceId, "LiveChatCtrl");
                                var savedTeam = $scope.teams.find(function (team) {
                                    return team.id === savedTeamId;
                                });
                                $scope.currentTeamId = savedTeam ? savedTeamId : $scope.teams[0].id;
                            }

                            $scope.teams.forEach(function (team) {

                                var ct = _config.teams.find(function (t) {
                                    return t.teamId === team.id;
                                });

                                team.channels = ct ? ct.channels : {};
                            });

                            liveChatService.initialise($scope.teams, $scope.currentTeamId, _users);
                        });
                }

                initialise();

                $scope.$on("$destroy", function () {
                    liveChatService.uninitialise();
                });

            }]);
})(window.angular);